import script from "./WCWebAdModern.vue?vue&type=script&setup=true&lang=ts"
export * from "./WCWebAdModern.vue?vue&type=script&setup=true&lang=ts"

import "./WCWebAdModern.vue?vue&type=style&index=0&id=0b8ec9b6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b8ec9b6"]])

export default __exports__